import React from "react";
import FormProvider from "@providers/FormProvider";
import Tabs from "@components/Tabs";
import ContentTab from "@components/Rooms/ContentTab";
import styles from "./SectionTabs.module.scss";
import { Form, useFormik } from "formik";
import cx from "classnames";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
// import helper from "@utils/helper";

const View = () => {
  const { rooms } = usePageContext();
  const data = rooms;
  let TABS: any = [
    {
      label: "all",
      key: "all",
      value: "all",
      order: 0,
      children: <ContentTab data={data} />,
    },
  ];
  const newData = _(data)
    .groupBy((item) => _.get(item, "attributes.category.data.attributes.slug"))
    .value();
  _.map(newData, (data, key) => {
    const newItem = {
      label: key,
      value: key,
      key: key,
      order: _.get(data, "0.attributes.category.data.attributes.order"),
      children: <ContentTab data={data} />,
    };
    TABS.push(newItem);
  });
  const form = useFormik({
    initialValues: {
      tab: "all",
    },
    onSubmit: async () => {
      return true;
    },
  });

  return (
    <section data-scroll-section className={cx("inner", styles.section)}>
      <FormProvider form={form}>
        <Form>
          <Tabs
            name="tab"
            className={styles.sectionTab}
            items={_.sortBy(TABS, (item) => item.order)}
          />
        </Form>
      </FormProvider>
    </section>
  );
};
export default View;
